import AppConfiguration from 'src/types/appConfiguration';

export default {
  siteTitle: 'SITE_TITLE_BILLON_UNIFIED_BLOCKCHAIN',
  documentPrivate: true,
  documentPublic: false,
  documentVerification: true,
  documentRemoteSigning: false,
  userLogin: false,
  userRegistration: false,
  userResetPassword: false,
  mockEndpoints: false,
  diploma: true,
  envPrefix: 'DEMO'
} as AppConfiguration;
